//created by sudip
import { motion } from "framer-motion";
import {
    BrainCircuit,
    Workflow,
    Database,
    ShieldCheck,
    Sparkles,
} from "lucide-react";

interface ActivityFeedProps {
    accent: string;
}

const activities = [

    {
        icon: BrainCircuit,
        title: "Predictive Recommendation Generated",
        description:
            "AI analysed operational data and generated a maintenance recommendation.",
        status: "AI Engine",
    },

    {
        icon: Workflow,
        title: "Workflow Automation Completed",
        description:
            "Customer onboarding workflow executed successfully across integrated systems.",
        status: "Automation",
    },

    // {
    //     icon: Database,
    //     title: "Enterprise Systems Synchronized",
    //     description:
    //         "ERP, CRM and inventory data synchronised across connected applications.",
    //     status: "Integration",
    // },

    // {
    //     icon: ShieldCheck,
    //     title: "Security Compliance Verified",
    //     description:
    //         "Cloud infrastructure passed automated compliance and security validation.",
    //     status: "Security",
    // },

    // {
    //     icon: Sparkles,
    //     title: "AI Insight Published",
    //     description:
    //         "Business intelligence engine detected emerging operational trends.",
    //     status: "Analytics",
    // },

];

export function ActivityFeed({

    accent,

}: ActivityFeedProps) {

    return (

        <motion.div
            initial={{
                opacity:0,
                y:24,
            }}
            animate={{
                opacity:1,
                y:0,
            }}
            transition={{
                delay:0.7,
                duration:0.6,
            }}
            className="
                mt-5
                rounded-3xl
                border
                border-slate-200
                bg-white
                p-4
                shadow-sm
            "
        >

            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-lg font-bold text-slate-900">
                        AI Activity Feed
                    </h3>
                    <p className="mt-1 text-sm text-slate-500">
                        Live platform intelligence
                    </p>
                </div>

                <span
                    className="rounded-full px-3 py-1 text-xs font-semibold"
                    style={{
                        backgroundColor:`${accent}18`,
                        color:accent,
                    }}
                >
                    LIVE
                </span>

            </div>

            <div className="mt-6 space-y-3">

                {activities.map((item,index)=>{

                    const Icon=item.icon;

                    return(

                        <motion.div

                            key={item.title}

                            initial={{
                                opacity:0,
                                x:-20,
                            }}

                            animate={{
                                opacity:1,
                                x:0,
                            }}

                            transition={{
                                delay:0.8+(index*0.08),
                            }}

                            className="
                                flex
                                items-start
                                gap-4
                                rounded-2xl
                                border
                                border-slate-100
                                p-4
                                transition-all
                                duration-300
                                hover:border-slate-200
                                hover:shadow-md
                            "
                        >

                            <div
                                className="
                                    flex
                                    h-11
                                    w-11
                                    items-center
                                    justify-center
                                    rounded-xl
                                "
                                style={{
                                    backgroundColor:`${accent}14`,
                                }}
                            >

                                <Icon
                                    className="h-5 w-5"
                                    style={{
                                        color:accent,
                                    }}
                                />

                            </div>

                            <div className="min-w-0 flex-1">

                                <div className="flex items-center justify-between gap-3">

                                    <h4 className="text-sm font-semibold text-slate-900">

                                        {item.title}

                                    </h4>

                                    <span
                                        className="flex-shrink-0 rounded-full bg-emerald-50 px-2 py-1 text-[11px] font-semibold text-emerald-700"
                                    >

                                        {item.status}

                                    </span>

                                </div>

                                {/* <p className="mt-2 text-sm leading-relaxed text-slate-500">
                                    {item.description}
                                </p> */}

                            </div>

                        </motion.div>

                    );

                })}

            </div>

        </motion.div>

    );

}